module.exports = ".mat-dialog-title {\n  margin: 0 0 10px 0;\n  font: 500 18px/32px Roboto, \"Helvetica Neue\", sans-serif; }\n\n.mat-input-container {\n  width: 100%; }\n\n.mat-dialog-actions {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form-views/components/data/save-view-dialog/save-view-dialog.component.scss
// module id = ./src/app/form-views/components/data/save-view-dialog/save-view-dialog.component.scss
// module chunks = main